const AlertCandidate = {
	All: {
		key: 'all',
		labelId: 'all_titles',
	},
	JustThoseUserHasTouched: {
		key: 'justThoseUserHasTouched',
		labelId: 'titles_you_edited',
	},
};

export default AlertCandidate;
